import Vue from 'vue';
import { debounce } from 'lodash';

Vue.component('load-more-component', {
    props: {
        items: {
            type: Array,
        },
        limit: {
            type: Object,
        },
        hasMasonry: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            posts: [],
            page: 1,
            actualLimit: 10,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.getPosts();
        window.addEventListener('resize', debounce(this.getPosts.bind(this), 500));
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.getPosts.bind(this));
    },

    watch: {
        actualLimit() {
            if (this.hasMasonry) {
                this.$nextTick(() => {
                    this.$parent.updateMasonry();
                });
            }
        },
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        getPosts() {
            this.posts = this.items.slice(0, this.getLimit());
        },

        getLimit() {
            for (let i = 0; i < Object.keys(this.limit).length; i++) {
                const min = Object.keys(this.limit)[i];
                const max = Object.keys(this.limit)[i + 1] ? Object.keys(this.limit)[i + 1] : null;

                if (window.innerWidth > +min && window.innerWidth < +max) {
                    this.actualLimit = this.limit[Object.keys(this.limit)[i]];
                    return this.actualLimit;
                }
                if (i === (Object.keys(this.limit).length - 1)) {
                    this.actualLimit = this.limit[min];
                    return this.actualLimit;
                }
            }
        },

        loadNextItems() {
            if (this.posts.length >= this.items.length) {
                return;
            }

            const newsBegin = this.page * this.actualLimit;
            this.page += 1;
            const newsEnd = this.page * this.actualLimit;
            const toAddPosts = this.items.slice(newsBegin, newsEnd);

            // if (!this.hasMasonry) {
            //     this.posts = [...this.posts, ...toAddPosts];
            //     return;
            // }

            this.posts = [...this.posts, ...toAddPosts];

            if (this.hasMasonry) {
                this.$nextTick(() => {
                    this.$parent.updateMasonry();
                });
            }
        },
    },
    filters: {
        dateFilter(date) {
            const months = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
            const withoutTime = date.split(' ')[0];
            const splittedDate = withoutTime.split('-');
            const formatDate = `${splittedDate[2]} ${months[Number(splittedDate[1]) - 1]} ${splittedDate[0]}`;
            return formatDate;
        },
    },
});
